var _context, _context2, _context3, _context4;
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import * as Yup from "yup";
import { DatePreference, SeasonName } from "./types.js";
import { formats } from "./weddingDateFormat.js";
export var validationSchema = Yup.object().shape({
  hideCountdown: Yup.bool(),
  hideDate: Yup.bool(),
  date: _trimInstanceProperty(_context = Yup.string()).call(_context).matches(/\d{4}-\d{2}-\d{2}/).when('preference', {
    is: function is(val) {
      return val === DatePreference.Exact;
    },
    then: Yup.string().required('Please enter a date.')
  }),
  rangeStart: _trimInstanceProperty(_context2 = Yup.string()).call(_context2).matches(/\d{4}-\d{2}-\d{2}/).nullable().when('preference', {
    is: function is(val) {
      return val === DatePreference.Range;
    },
    then: Yup.string().required('Please enter a start date.')
  }),
  rangeEnd: _trimInstanceProperty(_context3 = Yup.string()).call(_context3).matches(/\d{4}-\d{2}-\d{2}/).nullable().when('preference', {
    is: function is(val) {
      return val === DatePreference.Range;
    },
    then: Yup.string().required('Please enter an end date.')
  }),
  season: Yup.string().ensure().when('preference', {
    is: function is(val) {
      return val === DatePreference.Season;
    },
    then: Yup.string().required('Please enter a season.')
  }).when('year', {
    is: function is(val) {
      return val !== '';
    },
    then: Yup.string().oneOf(_Object$values(SeasonName)).required()
  }),
  year: Yup.string().ensure().when('preference', {
    is: function is(val) {
      return val === DatePreference.Season;
    },
    then: Yup.string().required('Please enter a year.')
  }).when('season', {
    is: function is(val) {
      return val !== '';
    },
    then: _trimInstanceProperty(_context4 = Yup.string()).call(_context4).matches(/\d{4}/).required()
  }),
  preference: Yup.string().oneOf(_Object$values(DatePreference)).required(),
  format: Yup.string().when('preference', {
    is: function is(val) {
      return val === DatePreference.Exact || val === DatePreference.Range;
    },
    then: Yup.string().oneOf(formats).required()
  })
}, [['season', 'year']]);